import React, { useEffect, useState } from 'react'
import DynamicForm from '../../../../../customformComponent/customForm/DynamicForm';
import axiosInstance from '../../../../../services/api/API';
import { useLocation } from 'react-router-dom';
import Loader from '../../../../../customComponents/CustomLoader';

const PurchaseAccrssories = ({po_id,vendorId,VendorID,  fetchPurchaseOrderDetails=()=>{},fetchDepartments=()=>{},fetchPurchaseOrderList=()=>{},toggleDrawer=()=>{},isEdit,activeComponent,podetailsID,bpid,formData,setFormData=()=>{}}) => {
 console.log("variantID",VendorID);
 
  
    //const [ formData, setFormData ] = useState({})
    const [validationErrors, setValidationErrors] = useState({});
    const [loading, setLoading] = useState(false)
    const [ userTypedd, setUserTypedd ] = useState([])
    const [ logisticsVariant, setLogisticsVariant ] = useState([])
    const [sparePartOptions,setSparePartOptions]= useState([])
    const [sparePartDetails,setSparePartDetails]=useState([])
    const [ variantDetails, setVariantDetails ] = useState({})
    const [ totalPrice, setTotalPrice ] = useState(0)
    const [ unit, setUnit ] = useState([])
    const [taxsetDropdown,setTaxSet] = useState([])
    const [taxPercentage, setTaxPercentage] = useState(0);
      const userType = localStorage.getItem("UserType")
      const [variantId,setVariantId]= useState(0)
      const businessPartnerId = localStorage.getItem("business_partner_id")
      const token = localStorage.getItem("authToken");
      useEffect(() => {
        const variantId = formData?.variant;
       console.log("bpid",bpid);
       
        if (variantId) { // Ensure variantId is not undefined or null
          console.log(variantId, 'VariantId', formData);
          fetchVariantDD(variantId);
        }
      }, [formData?.variant]);
      const location = useLocation()
      console.log("Location>>",location);
      
      const StockItemId=location?.state?.data?.phystkin_item_id
      const business_partner_id=location?.state?.data?.business_partner_id
    
      const fetchVariantDD = async (variantId) => {
        try{
          const response = await axiosInstance.post("/variant/ddlvariantbasedetails",{
            variant_id:variantId
          },{
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
    
          const fetchedData = response?.data?.data?.data[0]
          console.log(fetchedData, "FETCHEDDATAAAAAA")

          setFormData({
            ...formData,
            make_name: fetchedData.make_name,
            make_id:fetchedData?.make_id,
            model_id:fetchedData?.model_id,
            model_name: fetchedData.model_name,
            product_name: fetchedData.product_name,
            product_id: fetchedData.product_id,
            subproduct_name: fetchedData.subproduct_name,
            subproduct_id: fetchedData.subproduct_id,
            
          })
          setVariantDetails(fetchedData)

          const totalPriceData = response?.data?.data?.data[0]?.exshowroom_price
          setTotalPrice(totalPriceData)
          console.log(totalPriceData, "TOTALpRICEDATA")
    
        }catch(error){
          console.log(error, "error")
        }
      }
      useEffect(() => {
        userTypedropdown()
      },[])
      
      const userTypedropdown = async () => {
        try{
          const response = await axiosInstance.get("/bp-onboard/bplist",{
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
      
          const data = response.data.data.data
          const userTypeOptions = data.map(user => ({
            value: user.onboard_id,
            label:user.bp_name,
          }))
          setUserTypedd(userTypeOptions)
        }catch(error) {
          console.log(error)
        }
      }
    const handleFormSubmit = async (formData) => {
      const errors = {};
      let isValid = true;
  
      VehicleInputs.forEach((field) => {
        if (field.validation && field.validation.required) {
          if (!formData[field.name]) {
            errors[field.name] = "This field is required";
            isValid = false;
          }else if (field.required && field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
            errors[field.name] = field.validation.message;
            isValid = false;
          }
        }
      });
  
      if (!isValid) {
        setValidationErrors(errors);
        return;
      }
      
      console.log("formData",formData,isEdit);

      try {
        setLoading(true)
        if(isEdit){
          const payload = {
            po_id:po_id,
            product_id:formData?.product_id,
            subproduct_id:formData?.subproduct_id,
            variant_id:formData?.variant,
            itemtype_id:2,
            itemtype:"A",
            item_id:formData?.accessories,  //// OTHER THEN   "itemtype":"V", Item_id is required
            unit_id:formData?.unitid,
            rate:formData?.unitprice,
            // total_price:String(formData?.total),
            taxset_id:formData?.taxset,
            tax:taxPercentage/100,
            taxset_amount:formData?.taxamount,
            quantity:formData?.goods_quantity,
            totalprice:formData?.finalamount,
            business_partner_id:bpid
              }
        
              if (userType === "superadmin") {
                payload.business_partner_id = bpid;
              } else {
                payload.business_partner_id = bpid;
              }
        
              const response = await axiosInstance.patch(`/podetails/update/${podetailsID}`, payload,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                }
              }
            );
              fetchDepartments();
        fetchPurchaseOrderDetails();

              toggleDrawer();
        }
        else{ const payload = {
          po_id:po_id,
          product_id:formData?.product_id,
          subproduct_id:formData?.subproduct_id,
          variant_id:formData?.variant,
          itemtype_id:2,
          itemtype:"A",
          item_id:formData?.accessories,  //// OTHER THEN   "itemtype":"V", Item_id is required
          unit_id:formData?.unitid,
          rate:formData?.unitprice,
          // total_price:String(formData?.total),
          taxset_id:formData?.taxset,
          tax:taxPercentage/100,
          taxset_amount:formData?.taxamount,
          quantity:formData?.goods_quantity,
          totalprice:formData?.finalamount,
          business_partner_id:bpid
            }
      
          
      
            const response = await axiosInstance.post('/podetails/create', payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              }
            }
          );
          fetchPurchaseOrderList();
        fetchPurchaseOrderDetails();

          toggleDrawer();
            }
     
        //navigate('/logistics/manage-stock/physical-stock-taking'); 
      } catch (error) {
        console.error('Error adding data:', error);
  
        console.error("Error submitting form:", error);
      } finally {
        setLoading(false);
      }
      console.log("clicked")
    };

    const VehicleInputs = [
     
        {
          name: "variant",
          label: "Variant",
          type: "dropdown",
          required: true,
          placeholder:"Select Variant",
          // disabled: fieldsdisabled,
          options:logisticsVariant,
    
          gridClass: "col-lg-12",
        },
        {
          name: "make_name",
          label: "Make",
          type: "text",
          placeholder:"Select Make",
          // options: logisticComapanies,
          // disabled: fieldsdisabled,
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
        {
          name: "model_name",
          label: "Model",
          type: "text",
          placeholder:"Select Model",
          // options: logisticComapanies,
          // disabled: fieldsdisabled,
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
        {
          name: "product_name",
          label: "Product",
          type: "text",
          placeholder:"Select Product",
          // options: logisticComapanies,
          // disabled: fieldsdisabled,
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
        {
          name: "subproduct_name",
          label: "SubProduct",
          type: "text",
          placeholder:"Select Subproduct",
          // options: logisticComapanies,
          // disabled: fieldsdisabled,
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
        {
          name: "accessories",
          label: "Accessories",
          type: "dropdown",
          options:sparePartOptions,
          required: true,
          validation:{required:true},
          gridClass: "col-lg-6",
        },
        {
          name: "unit",
          label: "Unit",
          placeholder:"Select Unit",
          type: "text",
         
          // disabled: fieldsdisabled,
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
       
       
      
        {
          name: "unitprice",
          label: "Price",
          type: "text",
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
        {
          name: "taxset",
          label: "Tax Set",
          type: "dropdown",
          options:taxsetDropdown,
          required: true,
          validation:{required:true},
          gridClass: "col-lg-6",
        },
        {
          name: "goods_quantity",
          label: "Goods Quantity",
          placeholder:"Select Goods Quantity",
          type: "text",
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
        {
          name: "taxamount",
          label: "Tax Amount",
          type: "text",
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
        {
          name: "finalamount",
          label: "Total",
          type: "text",
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },


    ]
    useEffect(() => {
      fetchLogisticsBaseVariant()
      fetchTaxSetDropdown();
      console.log("formData",formData);
      
     
  },[])

  useEffect(()=>{
    console.log("formdatagoods",formData);
    
if(formData?.taxset || formData?.goods_quantity){
 // console.log("fomrdata");
  
  const selectedTaxSet = taxsetDropdown?.find(option => option?.value === formData?.taxset);
  console.log("selectedTaxSet",selectedTaxSet);
  const totalprice=Number(formData?.unitprice) *Number(formData?.goods_quantity)
  const validTotalPrice = isNaN(totalprice) ? 0 : totalprice;
  console.log("totalprice",formData?.unitprice*formData?.goods_quantity,totalprice);
  
  const taxPercent = selectedTaxSet ? selectedTaxSet.tax_percent : 0;
  const taxAmount = totalprice  * (taxPercent/100)
  const validTaxAmount = isNaN(taxAmount) ? 0 : taxAmount;

  console.log("taxamount",taxAmount);
  setTaxPercentage(taxPercent);
  setFormData({
    ...formData,taxamount:parseFloat(validTaxAmount).toFixed(1),finalamount:(parseFloat(validTotalPrice) + parseFloat(validTaxAmount)).toFixed(1)
  })
  console.log("finalformdata",formData);
  


}
  },[formData?.taxset,formData?.goods_quantity])
  
  const fetchTaxSetDropdown = async () => {
    try {
      const response = await axiosInstance.post('/tax/ddltax', {
       
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response?.data?.data?.data
      console.log(formattedData, "VARIANTDATA")

      const variantData = formattedData.map(data => ({
        value:data.ID,
        label:data.NAME,
        tax_percent:data?.tax_percent
        
      }))

      setTaxSet(variantData)
      
    } catch (error) {
      console.error('Error fetching department list:', error);
    }
  };

    const fetchLogisticsBaseVariant = async () => {
      try {
        const response = await axiosInstance.post('/physicalstocktakeitem/ddllogisticbasevariant', {
          vendor_id: vendorId || VendorID,
          business_partner_id:business_partner_id||bpid,
          itemtype:"A",
        }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }
        });
  
        const formattedData = response?.data?.data?.data
        console.log(formattedData, "VARIANTDATA")
  
        const variantData = formattedData.map(data => ({
          value:data.ID,
          label:data.NAME
        }))
  
        setLogisticsVariant(variantData)
        console.log(logisticsVariant, "LOGISTICSVARIANTID")
  
        console.log("response",response); 
      } catch (error) {
        console.error('Error fetching department list:', error);
      }
    };

    useEffect (()=>{
      if(formData?.variant){
        const fetchSparePartOptions = async() => {
          try {
          const sparepartResponse = await axiosInstance.post('/physicalstocktakeitem/ddllogisticbaseitem', {vendor_id:vendorId || VendorID,
      itemtype:"A",
      variant_id:formData?.variant ,
    business_partner_id:bpid}, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });
          const spareOptions = sparepartResponse.data.data.data?.map(product => ({
            label:product.NAME,
            value: product.ID,
          }));
          setSparePartOptions(spareOptions);
        } catch (error) {
          console.log(error);
          
          
        }
      }
      fetchSparePartOptions()
      }
    },[formData?.variant])
    useEffect(() => {
      
     console.log("formData",formData);
     
      if (formData?.accessories) { // Ensure variantId is not undefined or null
       
        fetchSparePartDetails(formData?.accessories);
      }
    }, [formData?.accessories]);

    
        const fetchSparePartDetails = async () => {
          try {
            const token = localStorage.getItem("authToken");
            
            const response = await axiosInstance.post('/item/ddllogisticitembase', {
            item_id:formData?.accessories,
            stock_type:"A",
            business_partner_id: bpid,
            vendor_id:vendorId ||VendorID
            }, {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            });
                const sparepartdetails = response?.data?.data?.data[0]
            setSparePartDetails(sparepartdetails)
            console.log("sparePartDetails",sparepartdetails);
            
        setFormData({
          ...formData,
          unit:sparepartdetails?.unit,
          unitid:sparepartdetails?.unit_id,
          unitprice:sparepartdetails?.purchase_price,  
        
        })
          } catch (error) {
            console.error("Error fetching variant options:", error);
          }
        };
 
    useEffect(() => {
      const fetchSparePartExistingDetails = async () => {
        console.log("api called");
        
        try {
          const response = await axiosInstance.get(`/podetails/edit/${podetailsID}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
    
          if (response.status === 200) {

            const vehicleData = response.data.data;
            console.log("vehicledata",vehicleData,response);
            
        
    
            const transformedData = {
              business_partner_id:vehicleData?.business_partner_id,
              productname: vehicleData.product_name,
              variant: vehicleData.variant_id,
             
              goods_quantity:vehicleData?.quantity,
              accessories: vehicleData?.item_id,
              unitprice:String(vehicleData?.rate),
              taxset:vehicleData?.taxset_id,
              taxamount:Number(vehicleData?.taxset_amount),
              finalamount:vehicleData?.totalprice,
             
             
            };
    
            setFormData(transformedData);
            fetchVariantDD(vehicleData.variant_id)
            fetchSparePartDetails(vehicleData?.accessories)          
            console.log("Transformed vehicle data set to formData:", transformedData);
          } else {
            console.error('Failed to fetch vehicle data');
          }
        } catch (error) {
          console.error('Error fetching vehicle data:', error);
        }
      };
    
      if (isEdit && activeComponent=="accessory") {
     
        fetchSparePartExistingDetails();
      }
    }, [isEdit]);
    

  return (
    <div>
    {loading ? (
      <Loader />
    ) : (
    <div>
        <DynamicForm
          formConfig={VehicleInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
            <button 
            onClick={() => {handleFormSubmit(formData)}}
            className="submit-btn"
            style={{marginTop:"15px", width:"85%"}}
            >
            Submit
            </button>
            </div>
      )}
    </div>
  )
}

export default PurchaseAccrssories;